(function () {
  'use strict';

  var FALLBACK_SRC =
    'https://cdn.shopify.com/s/files/1/0683/1597/1778/files/IMG_3010.png?v=1781284521';

  function bindImageFallbacks(root) {
    root.querySelectorAll('.amr-text-marquee__image-item img').forEach(function (img) {
      if (img.dataset.amrTmBound === 'true') {
        return;
      }
      img.dataset.amrTmBound = 'true';

      var fallback = img.getAttribute('data-fallback-src') || FALLBACK_SRC;
      img.addEventListener('error', function onError() {
        if (img.src === fallback) {
          return;
        }
        img.removeEventListener('error', onError);
        img.src = fallback;
      });
    });
  }

  function initSection(section) {
    if (!section || section.dataset.amrTmInit === 'true') {
      return;
    }
    section.dataset.amrTmInit = 'true';
    bindImageFallbacks(section);
  }

  function initAll() {
    document.querySelectorAll('.amr-text-marquee-section').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target && event.target.querySelector
      ? event.target.querySelector('.amr-text-marquee-section')
      : null;
    if (!section && event.target && event.target.classList && event.target.classList.contains('amr-text-marquee-section')) {
      section = event.target;
    }
    if (section) {
      initSection(section);
    }
  });
})();
